<template>
    <div class="form-horizontal">
        <div class="form-group">
            <label for="first_name_client_modal" class="col-xs-12 col-md-4 control-label">{{ $t('common.first_name') }}*</label>
            <div class="col-xs-12 col-md-8">
                <input class="form-control"
                       type="text"
                       placeholder="es: Mario"
                       name="first_name_client_modal"
                       id="first_name_client_modal"
                       v-model="newClient.first_name">
            </div>
        </div>
        <div class="form-group">
            <label for="last_name_client_modal" class="col-xs-12 col-md-4 control-label">{{ $t('common.last_name') }}*</label>
            <div class="col-xs-12 col-md-8">
                <input class="form-control"
                       type="text"
                       placeholder="es: Rossi"
                       id="last_name_client_modal"
                       name="last_name_client_modal"
                       v-model="newClient.last_name">
            </div>
        </div>
        <div class="form-group">
            <label for="phone_name_client_modal" class="col-xs-12 col-md-4 control-label">{{ $t('common.phone') }}*</label>
            <div class="col-xs-12 col-md-8">
                <VuePhoneNumberInput
                        @update="updatePhoneNumber"
                        no-validator-state
                        :default-country-code="country_phone"
                        v-model="newClient.phone_number"
                        :translations="translations"
                        id="phone_name_client_modal"></VuePhoneNumberInput>
            </div>
        </div>
        <div class="form-group">
            <label for="email_name_client_modal" class="col-xs-12 col-md-4 control-label">{{ $t('common.email') }}*</label>
            <div class="col-xs-12 col-md-8">
                <input class="form-control"
                       type="email"
                       placeholder="es: esempio@gmail.com"
                       id="email_name_client_modal"
                       name="email_name_client_modal"
                       v-model="newClient.email">
            </div>
        </div>
        <div class="form-group" v-show="isAcsiCompany">
            <label for="acsi_client_modal" class="col-xs-12 col-md-4 control-label">{{ $t('client.acsi_card') }}</label>
            <div class="col-xs-12 col-md-8">
                <input class="form-control"
                       type="text"
                       id="acsi_client_modal"
                       name="acsi_client_modal"
                       v-model="newClient.acsi_card">
            </div>
        </div>
        <div class="form-group">
            <label for="note_client_modal" class="col-xs-12 col-md-4 control-label">{{ $t('client.note') }}</label>
            <div class="col-xs-12 col-md-8">
                <textarea class="form-control"
                       id="note_client_modal"
                       name="note_client_modal"
                       v-model="newClient.note"></textarea>
            </div>
        </div>
    </div>
</template>

<script>
    import parsePhoneNumber from 'libphonenumber-js'
    import VuePhoneNumberInput from 'vue-phone-number-input';
    import 'vue-phone-number-input/dist/vue-phone-number-input.css'
    import {StorageHelper} from "../../common/storageHelper";
    import {Utils} from "../../common/utils";

    export default {
        name: "AppointmentForm",
        props: {
            newClientProp: {
                type: Object,
                required: true
            }
        },
        components: {VuePhoneNumberInput},
        data: () => {
            return {
                isAcsiCompany: false,
                clientCountry: null,
                newClient: {
                    client_id: null,
                    first_name: null,
                    last_name: null,
                    email: null,
                    phone_number: null,
                    acsi_card: null,
                    note: null,
                    phone_number_international: null,
                },
                translations: Utils.getTranslationsPhoneField()
            }
        },
        methods: {
            updatePhoneNumber(result) {
                this.newClient.phone_number_international = result.formatInternational;
            }
        },
        mounted: function () {
            this.newClient = Object.assign({}, this.newClientProp);
            const user = StorageHelper.getUser();
            this.isAcsiCompany = user.company.is_acsi;
        },
        computed: {
            country_phone() {
                if (this.clientCountry) {
                    return this.clientCountry
                }
                return Utils.getDefaultCountry();
            }
        },
        watch: {
            newClientProp: function(newVal) {
                const phoneNumber = parsePhoneNumber(newVal.phone_number);
                this.clientCountry = phoneNumber.country;
                this.newClient = Object.assign({}, newVal);
            },
            newClient: {
                handler(newVal) {
                    this.$emit('change', Object.assign({}, newVal))
                },
                deep: true,
            }
        }
    }
</script>